<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span>{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.TITLE' | translate }}</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body bank-statement-modal-body py-0 d-flex flex-column">
  <div class="modal-top-section d-flex">
    <div class="w-40">
      <div [formGroup]="statementsFilterForm">
        <div class="row">
          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.AMOUNT' | translate }}</label>
              <input type="text" class="form-control" formControlName="amount" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.PAYEE' | translate }}</label>
              <input type="text" class="form-control" formControlName="payee" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.DATE' | translate }}</label>
              <app-date-picker [FormControl]="statementsFilterForm.get('date')" [required]="false"> </app-date-picker>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label>{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.DESCRIPTION' | translate }}</label>
              <input type="text" class="form-control" formControlName="description" />
            </div>
          </div>

          <!--          <div class="col-sm-1">-->
          <!--            <div class="form-group">-->
          <!--              <label-->
          <!--                class="form-check-label">{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.HAS_STATEMENT_LINKED' | translate }}</label>-->
          <!--              <select class="form-control" formControlName="has_payment_links">-->
          <!--                <option [ngValue]="null">-->
          <!--                  {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.ALL' | translate }}-->
          <!--                </option>-->
          <!--                <option [ngValue]="'1'">-->
          <!--                  {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.LINKED' | translate }}-->
          <!--                </option>-->
          <!--                <option [ngValue]="'0'">-->
          <!--                  {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.NOT_LINKED' | translate }}-->
          <!--                </option>-->
          <!--              </select>-->
          <!--            </div>-->
          <!--          </div>-->

          <div class="col-sm-2">
            <button class="btn btn-link btn-xs" (click)="clearStatementsFilters()">
              {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.CLEAR' | translate }}
            </button>
            <br />
            <button class="btn btn-success btn-input" (click)="loadStatements()">
              {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.SEARCH' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="modal-section-title">
        {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.SELECT_ONE_OR_MORE_STATEMENTS' | translate }}
      </div>
    </div>

    <div class="w-60 ps-1">
      <div [formGroup]="paymentsFilterForm">
        <div class="row">
          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.AMOUNT' | translate }}</label>
              <input type="number" class="form-control" formControlName="amount" />
            </div>
          </div>

          <div class="col-sm-1">
            <app-currency-select [parentFormGroup]="paymentsFilterForm" passFormControlName="currency_id">
            </app-currency-select>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.DATE' | translate }}</label>
              <app-date-picker [FormControl]="paymentsFilterForm.get('date')" [required]="false"> </app-date-picker>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.REFERENCE' | translate }}</label>
              <input type="text" class="form-control" formControlName="reference" />
            </div>
          </div>

          <div class="col-sm-4">
            <app-clientable-select [parentFormGroup]="paymentsFilterForm"></app-clientable-select>
          </div>

          <!--          <div class="col-sm-1">-->
          <!--            <div class="form-group">-->
          <!--              <label-->
          <!--                class="form-check-label">{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.HAS_PAYMENT_LINKED' | translate }}</label>-->
          <!--              <select class="form-control" formControlName="has_statement_links">-->
          <!--                <option [ngValue]="null">-->
          <!--                  {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.ALL' | translate }}-->
          <!--                </option>-->
          <!--                <option [ngValue]="'1'">-->
          <!--                  {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.LINKED' | translate }}-->
          <!--                </option>-->
          <!--                <option [ngValue]="'0'">-->
          <!--                  {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.NOT_LINKED' | translate }}-->
          <!--                </option>-->
          <!--              </select>-->
          <!--            </div>-->
          <!--          </div>-->

          <div class="col-sm-1">
            <button class="btn btn-link btn-xs" (click)="clearPaymentsFilters()">
              {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.CLEAR' | translate }}
            </button>
            <br />
            <button class="btn btn-success btn-input" (click)="loadPayments()">
              {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.SEARCH' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="modal-section-title">
        {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.SELECT_ONE_OR_MORE_PAYMENTS' | translate }}
      </div>
    </div>
  </div>

  <div class="flex-grow-1 relative d-flex overflow-hidden">
    <div class="w-40">
      <div class="statement-wrapper">
        <kendo-grid
          [style.height]="'100%'"
          [data]="statementsData"
          [pageable]="false"
          [sortable]="false"
          [loading]="statementsLoading"
        >
          <kendo-grid-column [width]="70" title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.NUMBER' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <button
                type="button"
                class="btn btn-success btn-ico align-top me-1"
                (click)="add(selectedStatements, dataItem)"
                [disabled]="dataItem?.meta_front?.selected"
              >
                <i class="fal fa-plus"></i>
              </button>

              {{ rowIndex + 1 }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="amount"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.AMOUNT' | translate }}"
            [width]="100"
          ></kendo-grid-column>

          <kendo-grid-column
            field="payee"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.PAYEE' | translate }}"
          ></kendo-grid-column>

          <kendo-grid-column
            field="date"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.DATE' | translate }}"
            [width]="90"
          >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              {{ dataItem.date | date : env.pipeDateFormat }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="description"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.DESCRIPTION' | translate }}"
          ></kendo-grid-column>
        </kendo-grid>
      </div>

      <hr class="my-1" />

      <div class="selected-statement-wrapper">
        <kendo-grid
          [style.height]="'100%'"
          [data]="selectedStatements"
          [pageable]="false"
          [sortable]="false"
          [hideHeader]="true"
        >
          <kendo-grid-column [width]="70" title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.NUMBER' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <button
                type="button"
                class="btn btn-danger btn-ico align-top me-1"
                (click)="remove(selectedStatements, dataItem, statementsData)"
              >
                <i class="fal fa-minus"></i>
              </button>

              {{ rowIndex + 1 }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="amount"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.AMOUNT' | translate }}"
            [width]="100"
          ></kendo-grid-column>

          <kendo-grid-column
            field="payee"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.PAYEE' | translate }}"
          ></kendo-grid-column>

          <kendo-grid-column
            field="date"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.DATE' | translate }}"
            [width]="90"
          >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              {{ dataItem.date | date : env.pipeDateFormat }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="description"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.DESCRIPTION' | translate }}"
          ></kendo-grid-column>
        </kendo-grid>
      </div>
    </div>

    <div class="w-60 ps-1">
      <div class="payment-wrapper">
        <kendo-grid
          [style.height]="'100%'"
          [data]="paymentsData"
          [pageable]="false"
          [sortable]="false"
          [loading]="paymentsLoading"
        >
          <kendo-grid-column [width]="70" title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.NUMBER' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <button
                type="button"
                class="btn btn-success btn-ico align-top me-1"
                (click)="add(selectedPayments, dataItem)"
                [disabled]="dataItem?.meta_front?.selected"
              >
                <i class="fal fa-plus"></i>
              </button>

              {{ rowIndex + 1 }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="id"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.ID' | translate }}"
            [width]="60"
          ></kendo-grid-column>

          <kendo-grid-column
            field="amount"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.AMOUNT' | translate }}"
            [width]="100"
          >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              {{ dataItem.amount }} {{ dataItem.currency?.code }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="date"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.DATE' | translate }}"
            [width]="90"
          >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              {{ dataItem.date | date : env.pipeDateFormat }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="reference"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.REFERENCE' | translate }}"
          ></kendo-grid-column>

          <kendo-grid-column
            [width]="100"
            field="cleanClientableType"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.CLIENTABLE_TYPE' | translate }}"
          ></kendo-grid-column>

          <kendo-grid-column
            field="clientable.name"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.CLIENTABLE_NAME' | translate }}"
          ></kendo-grid-column>

          <kendo-grid-column
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.ACTIONS' | translate }}"
            [width]="50"
            [class]="'text-center'"
          >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <app-edit-button (click)="editPayment(dataItem)"> </app-edit-button>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>

      <hr class="my-1" />

      <div class="selected-payment-wrapper">
        <kendo-grid
          [style.height]="'100%'"
          [data]="selectedPayments"
          [pageable]="false"
          [sortable]="false"
          [hideHeader]="true"
        >
          <kendo-grid-column [width]="70" title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.NUMBER' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <button
                type="button"
                class="btn btn-danger btn-ico align-top me-1"
                (click)="remove(selectedPayments, dataItem, paymentsData)"
              >
                <i class="fal fa-minus"></i>
              </button>

              {{ rowIndex + 1 }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="amount"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.AMOUNT' | translate }}"
            [width]="100"
          >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              {{ dataItem.amount }} {{ dataItem.currency?.code }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="date"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.DATE' | translate }}"
            [width]="90"
          >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              {{ dataItem.date | date : env.pipeDateFormat }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="reference"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.REFERENCE' | translate }}"
          ></kendo-grid-column>

          <kendo-grid-column
            [width]="100"
            field="cleanClientableType"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.CLIENTABLE_TYPE' | translate }}"
          ></kendo-grid-column>

          <kendo-grid-column
            field="clientable.name"
            title="{{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.CLIENTABLE_NAME' | translate }}"
          ></kendo-grid-column>
        </kendo-grid>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-dark btn-xs"
    (click)="save()"
    [disabled]="selectedPayments?.length <= 0 || selectedStatements?.length <= 0"
  >
    {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.SAVE' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-outline-dark btn-xs ms-2"
    (click)="saveAndClose()"
    [disabled]="selectedPayments?.length <= 0 || selectedStatements?.length <= 0"
  >
    {{ 'BANKS.BANK_ACCOUNTS_STATEMENTS_MATCH_FORM.SAVE_AND_CLOSE' | translate }}
  </button>
</div>
